module.exports = __webpack_public_path__ + "img/120ne.8240c54f.svg";